import { colors } from '@atlaskit/theme';

export default {
  // Primary color of application
  primary: '#0747a6',

  // It is recommended for use in border colors.
  border: colors.N40,

  // It is recommended to use light colored floors.
  background: colors.N20,
};
